import { useLazyQuery, useQuery, WatchQueryFetchPolicy } from "@apollo/client";
import { useVisitor } from "@ct-react/visitor";
import { CART_BADGE_GQL_DATA } from "@shared/gql/queries";

export const useCartBadge = () => {
  const { isLoggedIn, ...variables } = useVisitor();
  const { data } = useQuery(CART_BADGE_GQL_DATA, { variables, nextFetchPolicy: "cache-only" });
  return data?.cart?.itemsCount ?? 0;
}

export const useCheckCartExpiration = (fetchPolicy: WatchQueryFetchPolicy = "no-cache" ) => {
  const { isLoggedIn, ...variables } = useVisitor();
  const [ getCount ] = useLazyQuery(CART_BADGE_GQL_DATA, { variables, fetchPolicy });
  return () => new Promise<number>((resolve, reject) => getCount()
    .then(({ data }) => !!data?.cart?.itemsCount
      ? resolve(data?.cart?.itemsCount)
      : reject())
    .catch(() => reject()));
}
